import { AppSidebar } from "./app-sidebar"
import { SidebarInset, SidebarProvider } from "@shared/components/ui/sidebar"
import { PanelInset, PanelsProvider } from "@shared/components/panels"
import { TopBar } from "./top-bar"

interface DashboardLayoutProps {
  children: React.ReactNode
}

export const DashboardLayout = ({ children }: DashboardLayoutProps): JSX.Element => {
  return (
    <PanelsProvider>
      <SidebarProvider>
        <div className="relative flex h-screen w-full overflow-hidden bg-background">
          <AppSidebar />
          <SidebarInset className="flex min-w-0 flex-1 flex-col">
            <PanelInset className="flex flex-col h-full" enablePanelPush={true}>
              <TopBar />
              <main className="relative flex flex-1 flex-col overflow-y-auto">
                <div className="flex flex-1 flex-col min-h-0">
                  {children}
                </div>
              </main>
            </PanelInset>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </PanelsProvider>
  )
}
